import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Hide } from 'pcln-design-system'
import cloneDeep from 'lodash/cloneDeep'
import { MobileHeader } from '../MobileHeader/MobileHeader'
import { ChangeSearchWrapper } from '../ChangeSearchWrapper/ChangeSearchWrapper'
import { executeSearch } from '../../lib/buildSearchURL'
import {
  getRemoveSlice,
  getUpdatedSlices,
  getSearchParams,
  getSwappedSlices,
  getAddSlice,
  getUpdateSlice,
  getChanged,
} from './helpers'

const ResponsiveChangeSearchHeader = ({
  defaultTripType,
  defaultCabinClass,
  defaultPassengers,
  defaultTripSlices,
  defaultUseFlexDates,
  queryParams = {},
  defaultAirports = {},
  urlRoot,
  isReshopExperience,
  hideFilter = false,
  backArrowClick,
  gtmLogger,
  ...props
}) => {
  const [tripType, setTripType] = useState(defaultTripType || 'RT')
  const [cabinClass, setCabinClass] = useState(defaultCabinClass || 'ECO')
  const [passengers, setPassengers] = useState(defaultPassengers || { adults: 1 })
  const [useFlexDates, setUseFlexDates] = useState(defaultUseFlexDates)
  const [tripSlices, setTripSlices] = useState(cloneDeep(defaultTripSlices))
  const [airports, setAirports] = useState(cloneDeep(defaultAirports))
  const [validationError, setvalidationError] = useState(false)

  const updateSlice = (index, key, val) => {
    const slices = getUpdateSlice(tripSlices, index, key, val)
    setTripSlices(slices)
  }

  const removeSlice = (index) => {
    const slices = getRemoveSlice(tripSlices, index)
    setTripSlices(slices)
  }

  const swapSlices = () => {
    const slices = getSwappedSlices(tripSlices)
    setTripSlices(slices)
  }

  const addSlice = () => {
    const slices = getAddSlice(tripSlices)
    setTripSlices(slices)
  }

  const updateSlicesForTripType = (tripType) => {
    if (tripType === 'MD' && validationError === false && tripSlices?.[1]?.destAirportCode !== null) {
      setvalidationError(false)
    }
    const slices = getUpdatedSlices(tripSlices, tripType)
    setTripSlices(slices)
  }

  const submitSearch = () => {
    if (!(tripType === 'MD' && tripSlices?.[1]?.destAirportCode === null)) {
      const params = getSearchParams({
        tripType,
        tripSlices,
        cabinClass,
        queryParams,
        passengers,
        useFlexDates,
        airports,
      })
      /* istanbul ignore next */
      if (gtmLogger && hideFilter && backArrowClick) {
        /* istanbul ignore next */
        const changed = getChanged({
          tripType,
          tripSlices,
          cabinClass,
          passengers,
          defaultCabinClass,
          defaultPassengers,
          defaultTripType,
          defaultTripSlices,
        })
        /* istanbul ignore next */
        gtmLogger(changed)
      }
      setAirports(cloneDeep(defaultAirports))
      setTripType(defaultTripType)
      setCabinClass(defaultCabinClass)
      setUseFlexDates(defaultUseFlexDates)
      setPassengers(defaultPassengers)
      setTripSlices(cloneDeep(defaultTripSlices))
      executeSearch(params, urlRoot, true)
    } else {
      setvalidationError(true)
    }
  }

  return (
    <Box>
      <Hide xl xxl>
        <MobileHeader
          {...props}
          tripType={tripType}
          setTripType={setTripType}
          cabinClass={cabinClass}
          setCabinClass={setCabinClass}
          passengers={passengers}
          setPassengers={setPassengers}
          useFlexDates={useFlexDates}
          setUseFlexDates={setUseFlexDates}
          tripSlices={tripSlices}
          validationError={validationError}
          setTripSlices={setTripSlices}
          submitSearch={submitSearch}
          updateSlicesForTripType={updateSlicesForTripType}
          addSlice={addSlice}
          swapSlices={swapSlices}
          removeSlice={removeSlice}
          updateSlice={updateSlice}
          airports={airports}
          setAirports={setAirports}
          isReshopExperience={isReshopExperience}
          hideFilter={hideFilter}
          backArrowClick={backArrowClick}
        />
      </Hide>
      <Hide xs sm md lg>
        <ChangeSearchWrapper
          {...props}
          tripType={tripType}
          setTripType={setTripType}
          cabinClass={cabinClass}
          setCabinClass={setCabinClass}
          passengers={passengers}
          setPassengers={setPassengers}
          useFlexDates={useFlexDates}
          setUseFlexDates={setUseFlexDates}
          tripSlices={tripSlices}
          setTripSlices={setTripSlices}
          submitSearch={submitSearch}
          updateSlicesForTripType={updateSlicesForTripType}
          addSlice={addSlice}
          swapSlices={swapSlices}
          removeSlice={removeSlice}
          updateSlice={updateSlice}
          airports={airports}
          setAirports={setAirports}
          isReshopExperience={isReshopExperience}
          hideFilter={hideFilter}
        />
      </Hide>
    </Box>
  )
}

ResponsiveChangeSearchHeader.propTypes = {
  defaultTripType: PropTypes.string,
  defaultCabinClass: PropTypes.string,
  defaultPassengers: PropTypes.object,
  defaultTripSlices: PropTypes.array,
  defaultAirports: PropTypes.object,
  isWhiteLabel: PropTypes.bool,
  pclnExpt: PropTypes.any,
  urlRoot: PropTypes.string,
  queryParams: PropTypes.object,
  filterOnClick: PropTypes.func,
  displayFlexibleDatesCheckbox: PropTypes.func,
  defaultUseFlexDates: PropTypes.bool,
  isReshopExperience: PropTypes.bool,
  hideFilter: PropTypes.bool,
  backArrowClick: PropTypes.func,
  gtmLogger: PropTypes.func,
  subLabelMap: PropTypes.objectOf({
    adults: PropTypes.string,
    youths: PropTypes.string,
    children: PropTypes.string,
    lapInfants: PropTypes.string,
  }),
  lapInfantLabel: PropTypes.string,
}

export { ResponsiveChangeSearchHeader }
